export default __webpack_public_path__ + "assets/images/657ea4e62aa49394a3bea54a8053dfe3.svg";